export default __webpack_public_path__ + "static/media/united_states_circle.22e90332.svg";